export const environment = {
  production: true,
  baseUrl: 'https://api.gittoolset.com/api/',
  stripePublicKeyTest: 'pk_test_51K7WBuCitu0qgh8Y0R23dURwjJuhpvjUk00WUU5jgHpT5xu2jGEytsEaqqfF6PoDbsC0Bi49L0skXDXGhhcNZ7hU00j6VQbzzj',
stripePublicKey: 'pk_live_51K7WBuCitu0qgh8YrZL2DxreF60Tj0frVI9IA9WRwYJ49L2Uw1CFeEGY8bjV8lvWQAMsVlzDAp96h8a97vd73Hwq00Q5eWtlxz' 
};
